const translationStyles1=window?.psh_configs?.selectedLanguage;
const checkLanguage=translationStyles1?.toLowerCase()?.substring(0,2)==="en"
const AdvanceThemeJson = {

    'controlsList' : {'Application':{'imgSrc' :''}, 
                      'Inputs' :  {'themeKey': 'InputStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Textbox.svg')}, 
                      'Button' :  {'themeKey': 'ButtonStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Button.svg')},
                      'Label' :  {'themeKey': 'LabelStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Button.svg')}, 
                      'Sections' :  {'themeKey': 'SectionStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Section.svg')},
                      'Horizontal Tabs' :  {'themeKey': 'HorizontalTabStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Tabs.svg')}, 
                     //  'Vertical Tabs' :  {'themeKey': 'VerticalTabStyle', 'imgSrc' : require('../../../../../../Icons/Controls/TabsV.svg')}, 
                     //  'Horizontal Wizard' :  {'themeKey': 'HorizontalWizardStyle', 'imgSrc' : require('../../../../../../Icons/Controls/WizardH.svg')}, 
                     //  'Vertical Wizard' :  {'themeKey': 'VerticalWizardStyle', 'imgSrc' : require('../../../../../../Icons/Controls/WizardV.svg')}, 
                      'Tables' :  {'themeKey': 'TableStyle', 'imgSrc' : require('../../../../../../Icons/Controls/Table.svg')}, 
                      'Doc List' : {'themeKey': 'DoclistStyle', 'imgSrc' : require('../../../../../../Icons/Controls/DocList.svg')}
                    },
    'Inputs' : {
            'layout' : {
                'header' : 'Input Layouts',
                'subHeader' : [
                    {'heading' : 'StyleType',
                     'children' : [
                        {'key':'ControlStyleTextbox', 'label' : 'Style1', 'imgSrc' :checkLanguage ?  require('../../../../../../Icons/Textbox1.svg') :require('../../../../../../Icons/Textbox1A.svg'), "styleCheck": checkLanguage? "true":"false"},
                        {'key':'ControlStyleTextbox', 'label' : 'Style2', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Textbox2.svg'): require('../../../../../../Icons/Textbox2A.svg'), "styleCheck": checkLanguage? "true":"false" },
                        {'key':'ControlStyleTextbox', 'label' : 'Style3', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Textbox3.svg'):require('../../../../../../Icons/Textbox3A.svg'), "styleCheck": checkLanguage? "true":"false"}
                     ]},
                     {'heading' : 'Radio',
                     'children' : [
                        {'key':'ControlStyleRadio', 'label' : 'Style1', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Radio-1.svg'): require('../../../../../../Icons/Radio-1A.svg'), "styleCheck": checkLanguage? "true":"false"},
                        {'key':'ControlStyleRadio', 'label' : 'Style2', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Radio-2.svg'): require('../../../../../../Icons/Radio-2A.svg'), "styleCheck": checkLanguage? "true":"false"},
                        {'key':'ControlStyleRadio', 'label' : 'Style3', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Radio-3.svg'): require('../../../../../../Icons/Radio-3A.svg'), "styleCheck": checkLanguage? "true":"false"}
                     ]},
                     {'heading' : 'Checkbox',
                     'children' : [
                        {'key':'ControlStyleCheckbox', 'label' : 'Style1', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Checkbox1.svg'):require('../../../../../../Icons/Checkbox1A.svg'), "styleCheck": checkLanguage? "true":"false"},
                        {'key':'ControlStyleCheckbox', 'label' : 'Style2', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Checkbox2.svg'):require('../../../../../../Icons/Checkbox2A.svg'), "styleCheck": checkLanguage? "true":"false"}
                     ]},
                     {'heading' : 'Toggle',
                     'children' : [
                        {'key':'ControlStyleToggle', 'label' : 'Style1', 'imgSrc' : require('../../../../../../Icons/Toggle1.svg')},
                        {'key':'ControlStyleToggle', 'label' : 'Style2', 'imgSrc' : require('../../../../../../Icons/Toggle2.svg')}
                     ]},
                     // {'heading' : 'Date Picker Type',
                     // 'children' : [
                     //    {'key':'DatepickerType', 'label' : 'Date', 'imgSrc' : require('../../../../../../Icons/DateGrey.svg')},
                     //    {'key':'DatepickerType', 'label' : 'Date & Time', 'imgSrc' : require('../../../../../../Icons/DateTimeGrey.svg')}
                       
                     // ]}
                ]
            },
            'style' : {
                'header' : 'Input Styles',
                'subHeader' : [
                  {'heading' : 'Date',
                  'children' : [
                     {'key': 'DateSeperator', 'label':'Date-Seperator'},
                     {'key': 'ThemeDateFormat', 'label':'Date-Format'},
                  ]},
                  {'heading' : 'Date Time',
                  'children' : [
                     {'key': 'DateTimeSeperator', 'label':'Date-Time-Seperator'},
                     {'key': 'ThemeDateFormat2', 'label':'Date-Time-Format'},
                  ]},
                    {'heading' : 'Inputs',
                     'children' : [
                        // {'key': 'DateSeperator', 'label':'Date-Seperator'},
                        // {'key': 'ThemeDateFormat', 'label':'Date-Format'},
                        // {'key': 'ThemeDateFormat2', 'label':'Date-Format'},
                        {'key': 'LabelValueAlignment', 'label':'Label-Value Alignment'},
                        {'key': 'LabelRatio', 'label':'Label-Ratio'}, 
                        {'key': 'BorderColor', 'label':'Border Color'}, 
                        {'key': 'BorderWidth', 'label':'Border Width'}, 
                        {'key': 'BorderRadius', 'label':'Border Radius'},
                     ]},
                     {'heading' : 'Label',
                     'children' : [
                        {'key': 'LabelFontFamily', 'label':''}, 
                        {'key': 'LabelFontSize', 'label':''},
                        {'key': 'LabelFontWeight', 'label':''}, 
                        {'key': 'LabelFontColor', 'label':''}
                     ]},
                     {'heading' : 'Value',
                     'children' : [
                        {'key': 'ValueFontFamily', 'label':''}, 
                        {'key': 'ValueFontSize', 'label':''},
                        {'key': 'ValueFontWeight', 'label':''}, 
                        {'key': 'ValueFontColor', 'label':''}
                     ]}
                ],
                'subHeaderArabic' : [
                  {'heading' : 'Date',
                  'children' : [
                     {'key': 'DateSeperator', 'label':'Date-Seperator'},
                     {'key': 'ThemeDateFormat', 'label':'Date-Format'},
                  ]},
                  {'heading' : 'Date Time',
                  'children' : [
                     {'key': 'DateTimeSeperator', 'label':'Date-Time-Seperator'},
                     {'key': 'ThemeDateFormat2', 'label':'Date-Time-Format'},
                  ]},
                    {'heading' : 'Inputs',
                     'children' : [
                        {'key': 'LabelValueAlignment', 'label':'Label-Value Alignment'},
                        {'key': 'LabelRatio', 'label':'Label-Ratio'}, 
                        {'key': 'BorderColor', 'label':'Border Color'}, 
                        {'key': 'BorderWidth', 'label':'Border Width'}, 
                        {'key': 'BorderRadius', 'label':'Border Radius'},
                        {'key': 'ArabicLanguage', 'label':'Date-Language'},
                        // {'key': 'EALanguage', 'label':'EALanguage'},
                     ]},
                     {'heading' : 'Label',
                     'children' : [
                        {'key': 'LabelFontFamily', 'label':''}, 
                        {'key': 'LabelFontSize', 'label':''},
                        {'key': 'LabelFontWeight', 'label':''}, 
                        {'key': 'LabelFontColor', 'label':''}
                     ]},
                     {'heading' : 'Value',
                     'children' : [
                        {'key': 'ValueFontFamily', 'label':''}, 
                        {'key': 'ValueFontSize', 'label':''},
                        {'key': 'ValueFontWeight', 'label':''}, 
                        {'key': 'ValueFontColor', 'label':''}
                     ]}
                ],
            }
            ,'themeKey': 'InputStyle'},

    'Button' : {
         'layout' : {
            'header' : 'Button Type',
            'subHeader' : [
               {'children' : [
                  {'key':'ControlStyle', 'label' : 'Primary', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/PrimaryButton.svg'): require('../../../../../../Icons/PrimaryButtonA.svg'),"styleCheck": checkLanguage ? "true":"false"},
                  {'key':'ControlStyle', 'label' : 'Secondary', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/SecondaryButton.svg'): require('../../../../../../Icons/SecondaryButtonA.svg'),"styleCheck": checkLanguage? "true":"false"},
                  {'key':'ControlStyle', 'label' : 'Text', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/TextButton.svg'): require('../../../../../../Icons/TextButtonA.svg'),"styleCheck": checkLanguage? "true":"false"}
               ]}
            ]
         },
        'style' : {
            'header' : 'Button Styles',
            'subHeader' : [
                 {'heading' : 'Primary Button',
                 'children' : [
                    {'key': 'PrimaryButtonFontFamily', 'label':'Font Family'}, 
                    {'key': 'PrimaryButtonFontSize', 'label':'Font Size'},
                    {'key': 'PrimaryButtonFontWeight', 'label':'Font Weight'}, 
                    {'key': 'PrimaryButtonFontColor', 'label':'Font Color'},
                    {'key': 'PrimaryButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'PrimaryButtonBorderRadius', 'label':'Border Radius'}
                 ]},
                 {'heading' : 'Secondary Button',
                 'children' : [
                     {'key': 'SecondaryButtonFontFamily', 'label':'Font Family'}, 
                     {'key': 'SecondaryButtonFontSize', 'label':'Font Size'},
                     {'key': 'SecondaryButtonFontWeight', 'label':'Font Weight'}, 
                     {'key': 'SecondaryButtonFontColor', 'label':'Font Color'},
                     {'key': 'SecondaryButtonBorderColor', 'label':'Border Color'},
                     {'key': 'SecondaryButtonBorderWidth', 'label':'Border Width'},
                     {'key': 'SecondaryButtonBorderRadius', 'label':'Border Radius'}
                 ]},
                 {'heading' : 'Text Button',
                 'children' : [
                     {'key': 'TextButtonFontFamily', 'label':'Font Family'}, 
                     {'key': 'TextButtonFontSize', 'label':'Font Size'},
                     {'key': 'TextButtonFontWeight', 'label':'Font Weight'}, 
                     {'key': 'TextButtonFontColor', 'label':'Font Color'}
                 ]}
            ]
        }
            ,'themeKey': 'ButtonStyle'},
    'Label' : {
        'style' : {
            'header' : 'Label Control',
            'subHeader' : [
                    {'heading' : 'Style',
                    'children' : [
                    {'key': 'FontFamily', 'label':''}, 
                    {'key': 'FontSize', 'label':''},
                    {'key': 'FontWeight', 'label':''}, 
                    {'key': 'FontColor', 'label':'Font Color'},
                    {'key': 'BackgroundColor', 'label':'Background Color'},
                    {'key': 'LabelAlignment', 'label':'Label Alignment'}
                    ]}
            ]
        }
            ,'themeKey': 'LabelStyle'},

    'Sections' : {
        'layout' : {
            'header' : 'Section Layouts',
            'subHeader' : [
                {'children' : [
                    {'key':'ControlStyle', 'label' : 'Style1', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Section1.svg'):require('../../../../../../Icons/Section1A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style2', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Section2.svg'):require('../../../../../../Icons/Section2A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style3', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Section3.svg'):require('../../../../../../Icons/Section3A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style4', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/Section4.svg'):require('../../../../../../Icons/Section4A.svg')}
                 ]}
            ]
        },
        'style' : {
            'header' : 'Section Style',
            'subHeader' : [
                {'heading' : 'Inputs',
                 'children' : [
                    {'key': 'FontFamily', 'label':''},
                    {'key': 'FontSize', 'label':''},
                    {'key': 'FontWeight', 'label':''},
                    {'key': 'FontColor', 'label':'Font Color'},
                    {'key': 'HeaderBackColor', 'label':'Header BG Color'},
                    {'key': 'BorderColor', 'label':'Border'},
                    {'key': 'BorderWidth', 'label':''}, 
                    {'key': 'BorderRadius', 'label':''},
                    {'key': 'HeaderFontAlignment', 'label':'HeaderFontAlignment'},
                    {'key': 'AccordionColor', 'label':'Accordian Icon Color'}
                 ]}
            ]
        }
            ,'themeKey': 'SectionStyle'},
    
    'Horizontal Tabs' : {
        'layout' : {
            'header' : 'Tabs Layouts',
            'subHeader' : [
                {
                 'children' : [
                    {'key':'ControlStyle', 'label' : 'Style1', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/HorizontalTabs1.svg'): require('../../../../../../Icons/HorizontalTabs1A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style2', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/HorizontalTabs2.svg'): require('../../../../../../Icons/HorizontalTabs2A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style3', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/HorizontalTabs3.svg'): require('../../../../../../Icons/HorizontalTabs3A.svg')},
                    {'key':'ControlStyle', 'label' : 'Style4', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/HorizontalTabs4.svg'): require('../../../../../../Icons/HorizontalTabs4A.svg')}
                 ]}
            ]
        },
        'style' : {
            'header' : 'Tab Style',
            'subHeader' : [
                {'heading' : 'Active Tab',
                 'children' : [
                    {'key': 'ActiveTabFontFamily', 'label':''}, 
                    {'key': 'ActiveTabFontSize', 'label':''},
                    {'key': 'ActiveTabFontWeight', 'label':''},
                    {'key': 'ActiveTabFontColor', 'label':'Font Color'}, 
                    {'key': 'ActiveTabBackColor', 'label':'Back Color'}
                 ]},
                 {'heading' : 'Inactive Tab',
                 'children' : [
                    {'key': 'InActiveTabFontFamily', 'label':''}, 
                    {'key': 'InActiveTabFontSize', 'label':''},
                    {'key': 'InActiveTabFontWeight', 'label':''}, 
                    {'key': 'InActiveTabFontColor', 'label':'Font Color'}, 
                    {'key': 'InActiveTabBackColor', 'label':'Back Color'}
                 ]},
                 {'heading' : 'Tab Appearance',
                 'children' : [
                    {'key': 'IconLabelAlignment', 'label':'Icon-Label Alignment'}, 
                    {'key': 'BorderColor', 'label':'Border Color'},
                    {'key': 'BorderWidth', 'label':'Border Width'}, 
                    {'key': 'BorderRadius', 'label':'Border Radius'}
                 ]},
                 {'heading' : 'Next Button',
                 'children' : [
                    {'key': 'NextButtonLabel', 'label':'Button Label'},
                    //{'key': 'NextButtonsType', 'label' : 'Button Style'},
                    {'key': 'NextButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'NextButtonFontFamily', 'label':''},
                    {'key': 'NextButtonFontColor', 'label':''},
                    {'key': 'NextButtonFontSize', 'label':''},
                    {'key': 'NextButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Save And Next Button',
                 'children' : [
                    {'key': 'SaveNextButtonLabel', 'label':'Button Label'},
                    //{'key': 'SaveNextButtonsType', 'label' : 'Button Style'},
                    {'key': 'SaveNextBackgroundColor', 'label':'Background Color'},
                    {'key': 'SaveNextFontFamily', 'label':''},
                    {'key': 'SaveNextFontColor', 'label':''},
                    {'key': 'SaveNextFontSize', 'label':''},
                    {'key': 'SaveNextFontWeight', 'label':''}
                 ]}
            ]
        },
        'CustomSpacingAdvTheme':
        [
         { Title: "4",  Value: "4px" },
         { Title: "8",  Value: "8px" },
         { Title: "12",  Value: "12px" },
         { Title: "16",  Value: "16px" },
         { Title: "20",  Value: "20px" },
         { Title: "24",  Value: "24px" },
         { Title: "28",  Value: "28px" },
         { Title: "32",  Value: "32px" },
         { Title: "36",  Value: "36px" },
         { Title: "40",  Value: "40px" },
         { Title: "44",  Value: "44px" },
         { Title: "48",  Value: "48px" },
       ],
            'themeKey': 'HorizontalTabStyle'},

    'Vertical Tabs' : {
        'layout' : {
            'header' : 'Tabs Layouts',
            'subHeader' : [
                {
                 'children' : [
                    {'key':'ControlStyle', 'label' : 'Style1', 'imgSrc' : require('../../../../../../Icons/Wizard/style1.svg'), 'imgStyle' : {'height' : '100%'}},
                    {'key':'ControlStyle', 'label' : 'Style2', 'imgSrc' : require('../../../../../../Icons/Wizard/style2.svg'), 'imgStyle' : {'height' : '100%'}},
                    {'key':'ControlStyle', 'label' : 'Style3', 'imgSrc' : require('../../../../../../Icons/Wizard/style3.svg'), 'imgStyle' : {'height' : '100%'}},
                 ]}
            ]
        },
        'style' : {
            'header' : 'Tab Style',
            'subHeader' : [
                {'heading' : 'Steps label',
                 'children' : [
                    {'key': 'LabelFontFamily', 'label':'Font Family'}, {'key': 'LabelFontSize', 'label':'Font Size'}
                 ]},
                {'heading' : 'Active Tab',
                 'children' : [
                    {'key': 'ActiveTabFontColor', 'label':'Font Color'}, 
                    {'key': 'ActiveTabBackgroundColor', 'label':'Background Color'}, 
                    {'key': 'ActiveTabFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Inactive Tab',
                 'children' : [
                    {'key': 'InActiveTabFontColor', 'label':'Font Color'}, 
                    {'key': 'InActiveTabFontWeight', 'label':'Font Weight'}, 
                    {'key': 'InActiveTabBackgroundColor', 'label':'Background Color'},
                    {'key': 'InActiveTabBorderColor', 'label':'Border Color'}
                 ]},
                 {'heading' : 'Tab Appearance',
                 'children' : [
                    {'key': 'TabAppearanceShowBorder', 'label':'Show Border'}, 
                    {'key': 'TabAppearanceBorderColor', 'label':'Border Color'},
                    {'key': 'TabAppearanceBorderWidth', 'label':'Border Width'} ,
                    {'key': 'TabAppearanceBorderRadius', 'label':'Border Radius'} 
                 ]},
                 {'heading' : 'Next Button',
                 'children' : [
                    {'key': 'NextButtonLabel', 'label':'Button Label'},
                    //{'key': 'NextButtonsType', 'label' : 'Button Style'},
                    {'key': 'NextButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'NextButtonFontFamily', 'label':''},
                    {'key': 'NextButtonFontColor', 'label':''},
                    {'key': 'NextButtonFontSize', 'label':''},
                    {'key': 'NextButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Save And Exit Button',
                 'children' : [
                    {'key': 'SaveExitButtonLabel', 'label':'Button Label'},
                    //{'key': 'SaveExitButtonsType', 'label' : 'Button Style'},
                    {'key': 'SaveExitButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'SaveExitButtonFontFamily', 'label':''},
                    {'key': 'SaveExitButtonFontColor', 'label':''},
                    {'key': 'SaveExitButtonFontSize', 'label':''},
                    {'key': 'SaveExitButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Back Button',
                 'children' : [
                    {'key': 'BackButtonLabel', 'label':'Button Label'},
                    //{'key': 'BackButtonsType', 'label' : 'Button Style'},
                    {'key': 'BackButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'BacktButtonFontFamily', 'label':''},
                    {'key': 'BackButtonFontColor', 'label':''},
                    {'key': 'BackButtonFontSize', 'label':''},
                    {'key': 'BackButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Cancel Button',
                 'children' : [
                    {'key': 'CancelButtonLabel', 'label':'Button Label'},
                    //{'key': 'CancelButtonsType', 'label' : 'Button Style'},
                    {'key': 'CancelButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'CancelButtonFontFamily', 'label':''},
                    {'key': 'CancelButtonFontColor', 'label':''},
                    {'key': 'CancelButtonFontSize', 'label':''},
                    {'key': 'CancelButtonFontWeight', 'label':''}
                 ]}
            ]
        }
            ,'themeKey': 'VerticalTabStyle'},

    'Horizontal Wizard' : {
        'layout' : {
            'header' : 'Wizard Layouts',
            'subHeader' : [
                {
                 'children' : [
                    {'key':'ControlStyle', 'label' : 'Style1', 'imgSrc' : require('../../../../../../Icons/HorizontalWizard1.svg')},
                    {'key':'ControlStyle', 'label' : 'Style2', 'imgSrc' : require('../../../../../../Icons/HorizontalWizard2.svg')},
                    {'key':'ControlStyle', 'label' : 'Style3', 'imgSrc' : require('../../../../../../Icons/HorizontalWizard3.svg')}
                 ]}
            ]
        },
        'style' : {
            'header' : 'Wizard Style',
            'subHeader' : [
                {'heading' : 'Steps label',
                 'children' : [
                    {'key': 'LabelFontFamily', 'label':'Font Family'}, 
                    {'key': 'LabelFontSize', 'label':'Font Size'}
                 ]},
                 {'heading' : 'Active Step',
                 'children' : [
                    {'key': 'ActiveStepFontColor', 'label':'Font Color'}, 
                    {'key': 'ActiveStepBackgroundColor', 'label':'Background Color'},
                    {'key': 'ActiveStepFontWeight', 'label':'Font Weight'},
                 ]},
                 {'heading' : 'Inactive Step',
                 'children' : [
                    {'key': 'InActiveStepFontColor', 'label':'Font Color'}, 
                    {'key': 'InActiveStepBackgroundColor', 'label':'Background Color'},
                    {'key': 'InActiveStepFontWeight', 'label':'Font Weight'},
                 ]},
                 {'heading' : 'Next Button',
                 'children' : [
                    {'key': 'NextButtonLabel', 'label':'Button Label'},
                    //{'key': 'NextButtonsType', 'label' : 'Button Style'},
                    {'key': 'NextBackgroundColor', 'label':'Background Color'},
                    {'key': 'NextButtonFontFamily', 'label':''},
                    {'key': 'NextButtonFontColor', 'label':''},
                    {'key': 'NextButtonFontSize', 'label':''},
                    {'key': 'NextButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Save And Exit Button',
                 'children' : [
                    {'key': 'SaveExitButtonLabel', 'label':'Button Label'},
                    //{'key': 'SaveExitButtonsType', 'label' : 'Button Style'},
                    {'key': 'SaveExitButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'SaveExitButtonFontFamily', 'label':''},
                    {'key': 'SaveExitButtonFontColor', 'label':''},
                    {'key': 'SaveExitButtonFontSize', 'label':''},
                    {'key': 'SaveExitButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Back Button',
                 'children' : [
                    {'key': 'BackButtonLabel', 'label':'Button Label'},
                    //{'key': 'BackButtonsType', 'label' : 'Button Style'},
                    {'key': 'BackButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'BacktButtonFontFamily', 'label':''},
                    {'key': 'BackButtonFontColor', 'label':''},
                    {'key': 'BackButtonFontSize', 'label':''},
                    {'key': 'BackButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Cancel Button',
                 'children' : [
                    {'key': 'CancelButtonLabel', 'label':'Button Label'},
                    //{'key': 'CancelButtonsType', 'label' : 'Button Style'},
                    {'key': 'CancelButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'CancelButtonFontFamily', 'label':''},
                    {'key': 'CancelButtonFontColor', 'label':''},
                    {'key': 'CancelButtonFontSize', 'label':''},
                    {'key': 'CancelButtonFontWeight', 'label':''}
                 ]}
            ]
        }
            ,'themeKey': 'HorizontalWizardStyle'},

    'Vertical Wizard' : {
        'layout' : {
            'header' : 'Wizard Layouts',
            'subHeader' : [
                {
                 'children' : [
                    {'key':'ControlStyle', 'label' : 'Style1', 'imgSrc' : require('../../../../../../Icons/VerticalWizard1.svg')},
                    {'key':'ControlStyle', 'label' : 'Style2', 'imgSrc' : require('../../../../../../Icons/VerticalWizard2.svg')},
                    {'key':'ControlStyle', 'label' : 'Style3', 'imgSrc' : require('../../../../../../Icons/VerticalWizard3.svg')}
                 ]}
            ]
        },
        'style' : {
            'header' : 'Wizard Style',
            'subHeader' : [
                {'heading' : 'Steps label',
                 'children' : [
                    {'key': 'LabelFontFamily', 'label':'Font Family'}, 
                    {'key': 'LabelFontSize', 'label':'Font Size'}
                 ]},
                 {'heading' : 'Active Step',
                 'children' : [
                    {'key': 'ActiveStepFontColor', 'label':'Font Color'}, 
                    {'key': 'ActiveStepBackgroundColor', 'label':'Background Color'},{'key': 'ActiveStepFontWeight', 'label':'Font Weight'},
                 ]},
                 {'heading' : 'Inactive Step',
                 'children' : [
                    {'key': 'InActiveStepFontColor', 'label':'Font Color'}, 
                    {'key': 'InActiveStepBackgroundColor', 'label':'Background Color'},
                    {'key': 'InActiveStepFontWeight', 'label':'Font Weight'},
                 ]},
                 {'heading' : 'Next Button',
                 'children' : [
                    {'key': 'NextButtonLabel', 'label':'Button Label'},
                    //{'key': 'NextButtonsType', 'label' : 'Button Style'},
                    {'key': 'NextButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'NextButtonFontFamily', 'label':''},
                    {'key': 'NextButtonFontColor', 'label':''},
                    {'key': 'NextButtonFontSize', 'label':''},
                    {'key': 'NextButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Save And Exit Button',
                 'children' : [
                    {'key': 'SaveExitButtonLabel', 'label':'Button Label'},
                    //{'key': 'SaveExitButtonsType', 'label' : 'Button Style'},
                    {'key': 'SaveExitButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'SaveExitButtonFontFamily', 'label':''},
                    {'key': 'SaveExitButtonFontColor', 'label':''},
                    {'key': 'SaveExitButtonFontSize', 'label':''},
                    {'key': 'SaveExitButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Back Button',
                 'children' : [
                    {'key': 'BackButtonLabel', 'label':'Button Label'},
                    //{'key': 'BackButtonsType', 'label' : 'Button Style'},
                    {'key': 'BackButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'BacktButtonFontFamily', 'label':''},
                    {'key': 'BackButtonFontColor', 'label':''},
                    {'key': 'BackButtonFontSize', 'label':''},
                    {'key': 'BackButtonFontWeight', 'label':''}
                 ]},
                 {'heading' : 'Cancel Button',
                 'children' : [
                    {'key': 'CancelButtonLabel', 'label':'Button Label'},
                    //{'key': 'CancelButtonsType', 'label' : 'Button Style'},
                    {'key': 'CancelButtonBackgroundColor', 'label':'Background Color'},
                    {'key': 'CancelButtonFontFamily', 'label':''},
                    {'key': 'CancelButtonFontColor', 'label':''},
                    {'key': 'CancelButtonFontSize', 'label':''},
                    {'key': 'CancelButtonFontWeight', 'label':''}
                 ]}
            ]
        }
            ,'themeKey': 'VerticalWizardStyle'},

    'Tables' : {
        'layout' : {
            'header' : 'Table Layouts',
            'subHeader' : [
                {
                 'children' : [
                    {'key':'ControlStyle', 'label' : 'Box', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/TableBox.svg') :require('../../../../../../Icons/TableBoxA.svg')},
                    {'key':'ControlStyle', 'label' : 'Striped', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/TableStriped.svg'):require('../../../../../../Icons/TableStripedA.svg')},
                    {'key':'ControlStyle', 'label' : 'Lined', 'imgSrc' :checkLanguage ? require('../../../../../../Icons/TableLined.svg'):require('../../../../../../Icons/TableLinedA.svg')},
                  //   {'key':'ControlStyle', 'label' : 'Cards', 'imgSrc' : require('../../../../../../Icons/TableCards.svg')}
                    // {'label' : 'Box', 'imgSrc' : require('../Icons/TableBox.svg')},
                    // {'label' : 'Striped', 'imgSrc' : require('../Icons/TableStriped.svg')},
                    // {'label' : 'Lined', 'imgSrc' : require('../Icons/TableLined.svg')},
                    // {'label' : 'Cards', 'imgSrc' : require('../Icons/TableCard.svg')}
                 ]}
            ]
        },
        'style' : {
            'header' : 'Table Style',
            'subHeader' : [
                {'heading' : '',
                 'children' : [
                    {'key': 'Add background behind Table', 'label':'Add background behind Table'}, 
                    {'key': 'TableBackgroundColor', 'label':'Background Color'}, 
                    {'key': 'TableBorderRadius', 'label':'Border Radius'}, 
                 ]},
                {'heading' : 'Table Title',
                 'children' : [
                    {'key': 'TableTitleFontFamily', 'label':'Font Family'}, 
                    {'key': 'TableTitleFontWeight', 'label':'Font Weight'}, 
                    {'key': 'TableTitleFontSize', 'label':'Font Size'}, 
                    {'key': 'TableTitleFontColor', 'label':'Font Color'},
                  //   {'key': 'BackgroundColor', 'label':'Background Color'}, 
                 ]},
                 {'heading' : 'Table Column',
                 'children' : [
                    {'key': 'TableColumnFontFamily', 'label':'Font Family'}, 
                    {'key': 'TableColumnFontWeight', 'label':'Font Weight'},
                    {'key': 'TableColumnFontSize', 'label':'Font Size'}, 
                    {'key': 'TableColumnTextAlignment', 'label':'Text Alignment'}, 
                    {'key': 'TableColumnBackgroundColor', 'label':'Background Color'}, 
                    {'key': 'TableColumnFontColor', 'label':'Font Color'}, 
                 ]},
                 {'heading' : 'Table Rows',
                 'children' : [
                    {'key': 'TableRowFontFamily', 'label':'Font Family'}, 
                    {'key': 'TableRowFontWeight', 'label':'Font Weight'}, 
                    {'key': 'TableRowFontSize', 'label':'Font Size'},
                    {'key': 'TableRowTextAlignment', 'label':'Text Alignment'},
                    {'key': 'TableRowFontColor', 'label':'Font Color'}, 
                    {'key': 'TableTSelectedRowColor', 'label':'Selected Row/Cell Color'}, 
                    {'key': 'TableRowBorderColor', 'label':'Border Color'},
                    {'key': 'Hover Effect', 'label':'Hover Effect'}
                 ]}
            ]
        }
            ,'themeKey': 'TableStyle'},

    'Doc List' : {
      //   'layout' : {
      //       'header' : 'Doc Type Layouts',
      //       'subHeader' : [
      //           {
      //           'children' : [
      //               {'key':'StylesOption', 'label' : 'Style1', 'imgSrc' : require('../../../../../../Icons/Doclist1.svg')},
      //               {'key':'StylesOption', 'label' : 'Style2', 'imgSrc' : require('../../../../../../Icons/Doclist2.svg')}
      //           ]}
      //       ]
      //   },
        'style' : {
            'header' : 'Doc Type Style',
            'subHeader' : [
                {'heading' : 'Document List label',
                'children' : [
                    {'key': 'DocumentListLabelFontFamily', 'label':'Font Family'}, 
                    {'key': 'DocumentListLabelFontSize', 'label':'Font Size'}, 
                    {'key': 'DocumentListLabelFontWeight', 'label':'Font weight'}, 
                    {'key': 'DocumentListLabelFontColor', 'label':'Font Color'}
                ]},
                {'heading' : 'Document Type label',
                'children' : [
                    {'key': 'DocumentTypeLabelFontFamily', 'label':''}, 
                    {'key': 'DocumentTypeLabelFontSize', 'label':''},
                    {'key': 'DocumentTypeLabelFontWeight', 'label':''}, 
                    {'key': 'DocumentTypeLabelFontColor', 'label':'Font Color'}, 
                  //   {'key': 'ButtonsType', 'label' : 'Upload Button Style'}
                ]}
            ]
        }
            ,'themeKey': 'DoclistStyle'},

    'smallDropdownList' : ['CornerRadius', 'BorderWidth', 'BorderRadius']
                 
}

export default AdvanceThemeJson;
